<!-- eslint-disable no-case-declarations -->
<!-- eslint-disable no-case-declarations -->
<template>
  <div class="invoice-table">
    <div class="label-container">
      <div
        v-if="rowData.isfHsCode != undefined || rowData.isfHsCode != null"
        class="label-item"
        style="margin-left: -40px;">
        <div class="label-mark">ISF税号</div>
        <el-tooltip :content="rowData.isfHsCode" placement="top">
          <div
            class="label-info"
            style="
              max-width: 140px;
              flex: 1;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            ">
            {{ rowData.isfHsCode }}
          </div>
        </el-tooltip>
      </div>
      <div class="label-item">
        <div class="label-mark">主单号</div>
        <div class="label-info">{{ rowData.mblNo }}</div>
      </div>
      <div v-if="rowData.containerNo" class="label-item">
        <div class="label-mark">柜号</div>
        <el-tooltip :content="rowData.containerNo" placement="top">
          <div
            class="label-info"
            style="
              max-width: 190px;
              flex: 1;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            ">
            {{ rowData.containerNo }}
          </div>
        </el-tooltip>
      </div>
      <div class="label-item">
        <div class="label-mark">提单件数</div>
        <div class="label-info">{{ rowData.qty }}</div>
      </div>
      <div class="label-item">
        <div class="label-mark">提单重量</div>
        <div class="label-info">{{ rowData.weightKgs }}</div>
      </div>
      <div v-if="!isShowBack" class="showTax">
        <span>总税金</span>
        <span class="num">{{ isNaN(sumData) ? 0 : sumData }}</span>
      </div>
      <div v-if="!isShowBack" class="showTax">
        <span>总杂费</span>
        <span class="num">{{ isNaN(incidentalsData) ? 0 : incidentalsData }}</span>
      </div>

      <div v-if="isShowBack" class="back" @click="cancel">
        <img src="@/assets/images/bill/back.png" />
        返回
      </div>
      <span class="tips">
        <span class="qun green"></span>
        客户修改
        <span class="qun red"></span>
        后台修改
      </span>
    </div>
    <el-table
      ref="invoiceData"
      v-loading="loading"
      class="invoice-table-container"
      :data="invoiceData"
      :header-cell-style="headerCellStyle"
      :cell-class-name="cellClassName"
      :height="height"
      :border="true"
      show-summary
      :summary-method="getSummaries"
      :cell-style="cellStyle"
      @cell-click="cellclick"
      @cell-dblclick="cellDblclick"
      @selection-change="selectionchange">
      <el-table-column v-if="isOpt" type="selection" width="40" :selectable="selectable" />
      <el-table-column type="index" label="序号" fixed="left" width="55">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
          <span
            v-if="
              scope.row.operationType === 0 || scope.row.operationType === 1
            "
            class="row-tips"
            :class="bgColor(scope.row)">{{ scope.row.operationType === 0 ? "增" : "删"
            }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, $index) in fileds"
        :key="$index"
        :prop="item.filed"
        :label="item.text"
        :width="item.width"
        :fixed="item.fixed"
        :align="item.align"
        show-overflow-tooltip>
        <template slot="header" slot-scope="scope">
          <div style="display: flex; align-items: center">
            {{ scope.column.label }}
            <span v-if="item.filed === 'nameCH' || item.filed === 'hsCode'" class="doubleClick">
              <svg-icon title="双击" iconClass="doubleClick" className="icon"></svg-icon>
            </span>
          </div>
        </template>

        <template slot-scope="scope">
          <template v-if="item.filed === 'opt'">
            <img
              v-if="scope.row.isEdit"
              style="cursor: pointer"
              src="@/assets/images/bill/unlock.png"
              @click="scope.row.isEdit = !scope.row.isEdit" />
            <img
              v-else
              style="cursor: pointer"
              src="@/assets/images/bill/lock.png"
              @click="scope.row.isEdit = !scope.row.isEdit" />
          </template>
          <template v-else-if="item.filed === 'isAluminumLicenseOrSteelLicense'">
            <span v-if="scope.row.isAluminumLicense || scope.row.isSteelLicense">99039101</span>
          </template>
          <template v-else-if="item.filed === scope.row.editFiled && isOpt">
            <component
              :is="getComponent(item.filed)"
              v-model="scope.row[item.filed]"
              size="mini"
              v-bind="getInputProps(item.filed)"
              :controls="false"
              @blur="filedChange(scope.row, scope.$index)"
              @change="filedChange(scope.row, scope.$index)" />
          </template>
          <template v-else-if="item.filed === 'hsCode'">
            {{ scope.row[item.filed] }}
            <img
              v-if="scope.row.isSteelLicense"
              style="vertical-align: -4px"
              src="@/assets/images/bill/tie.png" />
            <img
              v-if="scope.row.isAluminumLicense"
              style="vertical-align: -4px"
              src="@/assets/images/bill/lv.png" />
            <el-popover
              v-if="
                            scope.row?.editJson?.length &&
                            ifHisTory(scope.row?.editJson, item.filed)
              "
              placement="right"
              trigger="hover"
              effect="dark"
              popper-class="popper_tooltip"
              :content="`修改前记录：${formatHistory(scope.row?.editJson, item)?.oldValue
              }`">
              <template slot="reference">
                <span>
                  <img
                    v-if="formatHistory(scope.row?.editJson, item)"
                    class="history"
                    src="@/assets/images/table/history.png" />
                </span>
              </template>
            </el-popover>
          </template>
          <template v-else-if="isBatchField(item.filed)">
            <svg-icon
              v-if="getExemptFlag(scope.row, item.filed)"
              style="width: 2em; height: 1em"
              title="豁免"
              icon-class="exempt"
              class-name="icon"></svg-icon>
            {{ getBatchValue(scope.row, item.filed) }}
            <el-popover
              v-if="
                            scope.row?.editJson?.length &&
                            ifHisTory(scope.row?.editJson, item.filed)
              "
              placement="right"
              trigger="hover"
              effect="dark"
              popper-class="popper_tooltip"
              :content="`修改前记录：${formatHistory(scope.row?.editJson, item)?.oldValue
              }`">
              <template slot="reference">
                <span>
                  <img
                    v-if="formatHistory(scope.row?.editJson, item)"
                    class="history"
                    src="@/assets/images/table/history.png" />
                </span>
              </template>
            </el-popover>
          </template>
          <template v-else-if="item.filed === 'totalAmount'">
            <el-popover placement="top-start" width="auto" trigger="hover">
              <pre style="font-weight: bold;">{{ scope.row.dutyFormula }}</pre>
              <i slot="reference" style="margin-right: 3px;color: black" class="el-icon-warning"></i>
            </el-popover>
            {{ scope.row[item.filed] }}
          </template>
          <template v-else>
            {{ scope.row[item.filed] }}
            <el-popover
              v-if="
                            scope.row?.editJson?.length &&
                            ifHisTory(scope.row?.editJson, item.filed)
              "
              placement="right"
              trigger="hover"
              effect="dark"
              popper-class="popper_tooltip"
              :content="`修改前记录：${formatHistory(scope.row?.editJson, item)?.oldValue
              }`">
              <template slot="reference">
                <span>
                  <img
                    v-if="formatHistory(scope.row?.editJson, item)"
                    class="history"
                    src="@/assets/images/table/history.png" />
                </span>
              </template>
            </el-popover>
          </template>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="isOpt && !isCheck" class="bottom" style="padding-top: 15px">
      <el-button v-if="$store.state.caches?.length > 0" class="btn prev" @click="prev">
        上一步
      </el-button>
      <el-button class="btn export" :loading="loading" @click="exportInvoice">导 出</el-button>
      <!-- <el-button class="btn save" @click="save">暂 存</el-button>
      <el-button v-if="invoiceSave.length > 0" class="btn cance" @click="xccancer">
        清除暂存
      </el-button> -->
      <el-button
        v-if="controlOverInvoicesId > 0"
        class="btn restore"
        :loading="loading"
        @click="restore">版本还原</el-button>
      <el-button class="btn ok" :loading="loading" @click="determineok">
        {{ isShowBack ? "确 定" : "通 过" }}
      </el-button>
      <el-button class="btn ok" @click="sdfk">审单反馈</el-button>

      <div class="footer">
        <div class="btn1" @click="merge">
          <img src="@/assets/images/bill/merge.png" />合并行
        </div>
        <div class="btn1" @click="deleteRow">
          <img src="@/assets/images/bill/delete.png" />删除行
        </div>
        <div class="btn1" @click="addRow">
          <img src="@/assets/images/bill/addRow.png" />新增行
        </div>
        <div class="btn1 edit" @click="editRow">
          <img src="@/assets/images/bill/unlock.png" />可编辑
        </div>
        <div class="btn1 unedit" @click="uneditRow">
          <img src="@/assets/images/bill/lock.png" />不可编辑
        </div>
        <span>已选择 <span class="length">{{ selections.length }}</span> 项</span>
        <div class="break"></div>
        <!-- 第二行按钮 -->
        <!-- <div class="btn1 Declare122" @click="insertMetal(11)">申报122</div>
        <div class="btn1 Tariffs301" @click="insertMetal(4)">豁免301</div>
        <div class="btn1 Tariffs122" @click="insertMetal(6)">豁免122</div>
        <div class="btn1 SteelAndAluminum" @click="insertMetal(0)">豁免钢铝铜</div>
        <div class="btn1 WoodTariffs" @click="insertMetal(3)">豁免木制</div>
        <div class="btn1 AutoParts" @click="insertMetal(2)">豁免轻卡配</div>
        <div class="btn1 TruckPartsTariffs" @click="insertMetal(5)">豁免中重卡配</div> -->
      </div>
    </div>

    <MergeDialog
      :dialogVisible="dialogVisible3"
      :mergeSelections="selections"
      @ok="mergeOk"
      @cancel="dialogVisible3 = false">
    </MergeDialog>

    <ProductDialog :dialogVisible="dialogVisible" @ok="productOk" @cancel="dialogVisible = false">
    </ProductDialog>

    <TaxDialog :dialogVisible="dialogVisible2" @ok="taxOk" @cancel="dialogVisible2 = false">
    </TaxDialog>

    <AddProductDialog :dialogVisible="dialogVisible4" @ok="addOk" @cancel="dialogVisible4 = false">
    </AddProductDialog>

    <!-- 弹窗部分 -->
    <el-dialog v-drag class="dialog" append-to-body :visible.sync="sdfkdialogVisible" title="审单反馈" width="36%">
      <el-form ref="form" :model="form" :rules="rules" style="margin-left: 25px">
        <el-form-item label="上传反馈文件" style="margin-top: -15px" prop="filePath">(<span
          style="color: red">最多上传5个文件</span>)<br />
          <el-upload
            class="upload-demo"
            :action="`/api/ControlOverInvoices/uploadInvoiceReviewFile`"
            drag
            :on-success="handleSuccess"
            :before-upload="beforeUpload"
            :on-progress="onProgress"
            :show-file-list="false">
            <i class="el-icon-plus"></i>
            <div class="el-upload__text">拖拽或<em>点击上传</em></div>
          </el-upload>

          <div class="fileList">
            <div v-for="(item, index) in fileList" :key="index" class="fileItem flex_c_c">
              <div class="left">
                <div class="file">
                  <p class="fileName" :title="item.fileName">
                    {{ item.fileName }}
                  </p>
                  <p class="fileSize">{{ filterSize(item.fileSize) }} MB</p>
                </div>
              </div>
              <div class="opt">
                <img src="@/assets/images/bill/review.png" @click="review(item)" />
                <img src="@/assets/images/bill/deleteFile.png" @click="deleteFile(index)" />
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item style="margin-top: -15px" label="建议" prop="advice">
          <el-popover v-if="rowData.reviewFeedback" placement="right-start" width="auto" trigger="hover">
            <pre>{{ rowData.reviewFeedback }}</pre>
            <el-button
              slot="reference"
              style="background: rgba(165, 90, 248, 0.1); color: #a55af8;"
              icon="el-icon-chat-dot-round"
              size="mini"
              round>最新反馈记录</el-button>
          </el-popover>
          <br />
          <el-input v-model="form.advice" type="textarea" :rows="4" placeholder="请输入内容" style="width: 580px">
          </el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="sdfkcancer">取 消</el-button>
        <!-- <el-button style="background: #ffffff; border: 1px solid #142e79" @click="advicesave()">暂 存</el-button> -->
        <el-button type="primary" :loading="loading" @click="ok">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog
      v-drag
      class="dialog"
      append-to-body
      :visible.sync="showCopperDialog"
      :title="`确定为选中的${selections.length}条数据添加钢铝铜豁免附加税吗？`"
      width="24%"
      :close-on-click-modal="false"
      :lock-scroll="true">
      <el-radio-group v-model="batchNoThreeExempt">
        <el-radio label="99038203">豁免批次99038203</el-radio>
        <el-radio label="99038213">豁免批次99038213</el-radio>
      </el-radio-group>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="showCopperDialog = false">取消</el-button>
          <el-button type="primary" @click="confirmCopperAction">确定</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import MergeDialog from '../dialog/MergeDialog.vue'
import ProductDialog from '../dialog/ProductDialog.vue'
import TaxDialog from '../dialog/TaxDialog.vue'
import AddProductDialog from '../dialog/AddProductDialog.vue'
import {
    reviewFeedbackForAdmin,
    systemInvoicePassForAdmin,
    restoreVersion
} from '@/api/bill'
// import { insertMetalList } from '@/api/systemapicore'
// import { supplierDrapdown } from '@/api/systemapicore'
import { derive } from '@/utils/common'
// import { mapGetters } from 'vuex'

// 材质相关常量（放在 script 顶部或 data 外）
const METAL_KEYWORDS = ['steel', 'aluminum', 'aluminium', 'iron', 'copper']
const INVALID_MATERIALS = ['metal', 'alloy'] // 笼统材质，禁止使用
export default {
    components: {
        MergeDialog,
        ProductDialog,
        TaxDialog,
        AddProductDialog
    },
    props: {
        mblType: {
            type: [Number, String],
            default: ''
        },
        rowData: {
            type: Object,
            default: () => { }
        },
        productList: {
            type: Array,
            default: () => []
        },
        isShowLock: {
            type: Boolean,
            default: true
        },
        isOpt: {
            type: Boolean,
            default: true
        },
        isShowBack: {
            // 是否显示返回按钮
            type: Boolean,
            default: true
        },
        isCoustomer: {
            // 是否是客户
            type: Boolean,
            default: false
        },
        controlOverInvoicesId: {
            // 发票ID
            type: [Number, String],
            default: 0
        },
        height: {
            type: [Number, String],
            default: 740
        },
        isExamine: {
            // 是否审单页面
            type: Boolean,
            default: false
        },
        isCheck: {
            // 是否查看页面
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            dialogVisible: false,
            dialogVisible2: false,
            dialogVisible3: false,
            dialogVisible4: false,
            dialogFormVisible8: false,
            dialogFormVisible9: false,
            sdfkdialogVisible: false,
            taxRefuseReasonlogVisible: false,
            customerDemandDialog: false,
            isshifouchaochu: false,
            aivisibleDialog: false,
            ailoading: false,
            importervisibleDialog: false,
            importerInitLoading: false,
            istihuanNewlist: false,
            isExemptAddRateTwo: false,
            showCopperDialog: false,
            isShowingError: false,
            batchNoThreeExempt: '99038203',
            originalAddRateTwoExempt: [], // 保存每个 item 原始的 isAddRateTwoExempt
            originalBatchNoTwoExempt: [], // 保存每个 item 原始的 batchNoTwoExempt
            selectRow: {},
            productData: [],
            companyOptions: [],
            supplierOptions: [],
            userGroupOptions: [],
            aioldproductData: [],
            selections: [],
            oldData: [], // 原始数据
            invoiceSave: [],
            sumData: 0,
            sumaddRateTwoData: '',
            incidentalsData: '',
            RefuseReason: '',
            form: { advice: '', filePath: '', fileName: '' },
            fileInfo: {},
            rules: {
                advice: [
                    { required: true, message: '请输入审单建议', trigger: 'change' }
                ]
            },
            editData: '',
            mbleditData: {},
            importerData: {},
            fileList: [],
            Demand: {}
        }
    },
    watch: {
        productList: {
            handler: function(newValue) {
                this.oldData = JSON.parse(JSON.stringify(newValue))
                // 从 sessionStorage 中获取数据
                const invidata = JSON.parse(
                    sessionStorage.getItem(`invoiceSave-${this.rowData.mblId}`)
                )
                if (
                    invidata &&
                    Array.isArray(invidata.invoicedata) &&
                    invidata.invoicedata.length > 0 &&
                    this.isExamine
                ) {
                    this.productData = [...invidata.invoicedata] // 复制一份原始数据
                    this.invoiceSave = [...invidata.invoicedata]
                } else {
                    this.productData = JSON.parse(JSON.stringify(newValue)) || []

                    // 如果 isExamine 为 true 且 productData 长度大于 0，过滤掉 operationType 为 1 的项
                    if (this.isExamine && this.productData.length > 0) {
                        this.productData = this.productData.filter(
                            (item) => item.operationType !== 1
                        )
                    }
                }
            },
            deep: true,
            immediate: true
        },
        invoiceData: {
            handler: function() {
                this.$nextTick(() => {
                    this.$refs.invoiceData?.doLayout()
                })
            },
            deep: true,
            immediate: true
        }
        // productList() {},
    },
    // eslint-disable-next-line vue/order-in-components
    computed: {
        fileds() {
            const fileds = [
                {
                    fixed: 'left',
                    filed: 'mark',
                    text: 'MARK',
                    width: '70px'
                },
                {
                    fixed: 'left',
                    filed: 'nameEN',
                    text: '英文品名',
                    minwidth: '120px',
                    maxwidth: '150px'
                },
                {
                    fixed: 'left',
                    filed: 'nameCH',
                    text: '中文品名',
                    width: '130px'
                },
                {
                    fixed: 'left',
                    filed: 'hsCode',
                    text: 'HSCODE',
                    width: '130px'
                },
                {
                    filed: 'batchNo',
                    text: '批1',
                    minwidth: '110px',
                    maxwidth: '130px'
                },
                {
                    filed: 'batchNoTwo',
                    text: '批2',
                    width: '45px'
                },
                {
                    filed: 'batchNoThree',
                    text: '批3',
                    width: '45px'
                },
                {
                    filed: 'batchNoFour',
                    text: '批4',
                    width: '45px'
                },
                {
                    filed: 'batchNoFive',
                    text: '批5',
                    width: '45px'
                },
                {
                    filed: 'batchNoSix',
                    text: '批6',
                    width: '45px'
                },
                {
                    filed: 'batchNoSeven',
                    text: '批7',
                    width: '45px'
                },
                {
                    filed: 'batchNoEight',
                    text: '批8',
                    width: '45px'
                },
                {
                    filed: 'isAluminumLicenseOrSteelLicense',
                    text: '钢铝许可',
                    width: '80px'
                },
                {
                    filed: 'originCountry',
                    text: '原产国',
                    width: '66px'
                },
                {
                    filed: 'material',
                    text: 'Material',
                    minwidth: '110',
                    maxwidth: '150'
                },
                {
                    filed: 'usedFor',
                    text: 'Used for',
                    width: '90px'
                },
                {
                    filed: 'packages',
                    text: 'Ctns',
                    minwidth: '90',
                    maxwidth: '100'
                },
                {
                    filed: 'qty',
                    text: 'Qty',
                    minwidth: '90',
                    maxwidth: '100'
                },
                {
                    filed: 'unitPrice',
                    text: '单价',
                    minwidth: '90',
                    maxwidth: '100'
                },
                {
                    filed: 'totalPrice',
                    text: '总价',
                    minwidth: '90',
                    maxwidth: '100px'
                },
                {
                    filed: 'netWeight',
                    text: 'Net.W',
                    minwidth: '100',
                    maxwidth: '130'
                },
                {
                    filed: 'grossWeight',
                    text: 'Gro.W',
                    minwidth: '100',
                    maxwidth: '130'
                },
                {
                    filed: 'steelAluminiumValues',
                    text: '钢铝铜值',
                    minwidth: '100',
                    maxwidth: '130'
                },
                {
                    filed: 'steelAluminiumNetWeight',
                    text: '钢铝铜净重',
                    width: '120px'
                },
                {
                    filed: 'unitNetWeight',
                    text: '单个净重',
                    width: '80'
                },
                {
                    filed: 'dutyAmount',
                    text: 'Duty',
                    width: '75px'
                },
                {
                    filed: 'mpfAmount',
                    text: 'MPF',
                    width: '75px'
                },
                {
                    filed: 'totalAmount',
                    text: '总税金',
                    fixed: 'right',
                    width: '100px'
                },
                {
                    filed: 'optimizationRemark',
                    text: '备注',
                    fixed: 'right',
                    width: '100px'
                }
            ]
            if (this.mblType === 0) {
                fileds.splice(fileds.length - 2, 0, {
                    filed: 'hmfAmount',
                    text: 'HMF',
                    width: '70px'
                })
            }

            if (this.isShowLock) {
                fileds.push({
                    filed: 'opt',
                    text: '可否编辑',
                    width: '81px',
                    align: 'center',
                    fixed: 'right'
                })
            }
            return fileds
        },
        totalQty() {
            return this.productData
                .filter((a) => a.operationType !== 1)
                .reduce((prev, next) => {
                    return prev + +next.packages
                }, 0)
        },
        totalWeight() {
            return +this.productData
                .filter((a) => a.operationType !== 1)
                .reduce((prev, next) => {
                    return prev + +next.grossWeight
                }, 0)
                .toFixed(2)
        },

        // 5. 税金计算主逻辑
        invoiceData() {
            const productList = [...this.productData]

            productList.forEach((item) => {
                // === 1. 基础字段计算 ===
                item.totalPrice = parseFloat((item.qty * item.unitPrice).toFixed(2)) || 0
                const totalPrice = item.totalPrice
                const netWeight = item.netWeight

                item.unitNetWeight = item.qty > 0 ? (netWeight / item.qty).toFixed(3) : 0
                item.unitGrossWeight = item.packages > 0 ? (item.grossWeight / item.packages).toFixed(2) : 0

                // === 2. 附加费用（重量/数量）===
                const weightAmount = item.baseRateWeight ? (netWeight * (item.baseRateWeight / 100)) : 0
                const quantityAmount = item.baseRateQuantity ? (item.qty * (item.baseRateQuantity / 100)) : 0

                // === 3. 税率解析（考虑豁免）===
                const baseRate = item.baseRate || 0
                const finalAddRate = (item.isAddRateExempt || item.batchNoExempt) ? 0 : (item.addRate || 0)
                let finalAddRateTwo = (this.isExemptAddRateTwo || item.isAddRateTwoExempt || item.batchNoTwoExempt) ? 0 : (item.addRateTwo || 0)
                const finalAddRateThree = (item.isAddRateThreeExempt || item.batchNoThreeExempt) ? 0 : (item.addRateThree || 0)
                const finalAddRateFour = (item.isAddRateFourExempt || item.batchNoFourExempt) ? 0 : (item.addRateFour || 0)
                const finalAddRateFive = (item.isAddRateFiveExempt || item.batchNoFiveExempt) ? 0 : (item.addRateFive || 0)
                const finalAddRateSeven = (item.isAddRateSevenExempt || item.batchNoSevenExempt) ? 0 : (item.addRateSeven || 0)
                const finalAddRateEight = (item.isAddRateEightExempt || item.batchNoEightExempt) ? 0 : (item.addRateEight || 0)
                const steelAlLicenseAddRate = (item.isSteelLicense || item.isAluminumLicense) ? 25 : 0

                // === 4. 判断各批次是否启用 ===
                const enabled = {
                    THREE: finalAddRateThree > 0,
                    FOUR: finalAddRateFour > 0,
                    FIVE: finalAddRateFive > 0,
                    SEVEN: finalAddRateSeven > 0,
                    EIGHT: finalAddRateEight > 0
                }

                // === 5. 设置钢铝/铜货值与净重（默认100%）===
                const steelAluValue = enabled.THREE ? totalPrice : 0
                item.steelAluminiumValues = steelAluValue
                item.steelAluminiumNetWeight = enabled.THREE ? netWeight : 0

                // === 6. 确定生效批次（优先级顺序）===
                let effectiveBatch = 'TWO' // 默认走 TWO（即 9903.03.01 的 +10%）
                if (enabled.THREE) {
                    effectiveBatch = 'THREE'
                } else if (enabled.FOUR) {
                    effectiveBatch = 'FOUR'
                } else if (enabled.SEVEN) {
                    effectiveBatch = 'SEVEN'
                } else if (enabled.FIVE) {
                    effectiveBatch = 'FIVE'
                } else if (enabled.EIGHT) {
                    effectiveBatch = 'EIGHT'
                }

                // === 7. 非 TWO 批次：豁免 TWO 加征（强制）===
                if (effectiveBatch !== 'TWO') {
                    item.batchNoTwoExempt = '99030306'
                    item.isAddRateTwoExempt = true
                    finalAddRateTwo = 0
                }

                // === 8. 构建税率数组（用于公式展示）===
                const rateComponents = [
                    { label: '基础税率', value: baseRate },
                    { label: '301加征', value: finalAddRate }
                ]

                // 默认包含 TWO 和 钢铝标识
                let totalRate = baseRate + finalAddRate + finalAddRateTwo + steelAlLicenseAddRate
                if (effectiveBatch !== 'TWO') {
                    rateComponents.push({ label: '钢铝标识', value: steelAlLicenseAddRate })
                } else {
                    rateComponents.push({ label: '122加征', value: finalAddRateTwo })
                    rateComponents.push({ label: '钢铝标识', value: steelAlLicenseAddRate })
                }

                // === 9. 计算关税（duty）和公式 ===
                let duty = 0
                let taxableValue = totalPrice
                let extraRates = []

                switch (effectiveBatch) {
                    case 'THREE':
                        taxableValue = steelAluValue
                        extraRates = [{ label: '钢铝铜加征', value: finalAddRateThree }]
                        break
                    case 'FOUR':
                        extraRates = [{ label: '半导体税', value: finalAddRateFour }]
                        break
                    case 'FIVE':
                        extraRates = [{ label: '轻型汽配加征', value: finalAddRateFive }]
                        break
                    case 'EIGHT':
                        extraRates = [{ label: '中&重型卡车及配件加征', value: finalAddRateEight }]
                        break
                    case 'SEVEN':
                        extraRates = [{ label: '木制加征', value: finalAddRateSeven }]
                        totalRate = baseRate + finalAddRate + finalAddRateSeven
                        rateComponents.splice(2) // 移除 TWO 和 钢铝标识
                        rateComponents.push({ label: '木制加征', value: finalAddRateSeven })
                        break
                    default:
                        break
                }

                // 更新总税率（除 SEVEN 外都含钢铝标识）
                if (effectiveBatch !== 'SEVEN') {
                    totalRate = baseRate + finalAddRate + steelAlLicenseAddRate + finalAddRateTwo +
                        (extraRates.reduce((sum, r) => sum + r.value, 0))
                    rateComponents.push(...extraRates)
                }

                duty = taxableValue * (totalRate / 100)

                // === 10. 格式化公式 ===
                const formatRate = (r) => `${r}%`
                const valueFormula = `${taxableValue.toFixed(2)}×(${rateComponents.map(r => formatRate(r.value)).join(' + ')})`
                const descFormula = `货值×(${rateComponents.map(r => r.label).join('+')})`

                // === 11. 总税金 & 其他费用 ===
                const formattedDuty = duty.toFixed(2)
                const formattedWeight = weightAmount.toFixed(2)
                const formattedQuantity = quantityAmount.toFixed(2)

                item.dutyAmount = (duty + weightAmount + quantityAmount).toFixed(2)
                this.setOtherAmounts(item)

                // 动态附加费文本
                const parts = []
                if (weightAmount > 0) parts.push(`+重量附加费(${formattedWeight})`)
                if (quantityAmount > 0) parts.push(`+数量附加费(${formattedQuantity})`)

                const mainLine = this.mblType === 0
                    ? `${item.totalAmount} = Duty(${formattedDuty})+MPF(${item.mpfAmount})+HMF(${item.hmfAmount})${parts.join('')}`
                    : `${item.totalAmount} = Duty(${formattedDuty})+MPF(${item.mpfAmount})${parts.join('')}`

                item.dutyFormula = [
                    mainLine,
                    `计算公式：${valueFormula}`,
                    `公式描述：${descFormula}`
                ].join('\n')
            })

            console.log('计算后的 productList：', productList)
            return productList
        }
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.$refs?.invoiceData.doLayout()
        })
    },
    methods: {
        /**
         * 校验单行材质是否合规
         * @param {Object} row - 数据行
         * @param {number} rowIndex - 行索引（用于错误提示）
         * @returns {{ valid: boolean, message?: string }}
         */
        validateMaterial(row, rowIndex) {
            const material = (row.material || '').toString().trim()
            if (!material) {
                return { valid: false, message: `第${rowIndex + 1}行：材质为空，请补充相关材质信息！` }
            }

            const lowerMaterial = material.toLowerCase()

            // 1. 禁止笼统材质（Metal/Alloy）
            const hasInvalidMaterial = INVALID_MATERIALS.some(word =>
                word.includes(lowerMaterial)
            )
            if (hasInvalidMaterial) {
                return {
                    valid: false,
                    message: `第${rowIndex + 1}行：材质 "${material}" 较笼统，请填写具体金属材质，例如钢/铝/铜/铁等！`
                }
            }

            // 2. 批次3启用时，必须包含具体金属关键词
            const finalAddRateThree = row.isAddRateThreeExempt || row.batchNoThreeExempt
                ? 0
                : (Number(row.addRateThree) || 0)
            const enabledBatchThree = finalAddRateThree > 0

            if (enabledBatchThree) {
                const containsMetal = METAL_KEYWORDS.some(keyword =>
                    lowerMaterial.includes(keyword)
                )
                if (!containsMetal) {
                    return {
                        valid: false,
                        message: `第${rowIndex + 1}行：批3申报钢铝铜但是材质不包含钢铝铜的英文材质信息！`
                    }
                }
            }

            // 3. 批次3豁免时，必须包含 '%' 字符（表示填写了成分百分比）
            const enabledBatchThreeExempt = row.batchNoThreeExempt !== undefined &&
                row.batchNoThreeExempt !== '' &&
                row.batchNoThreeExempt !== null

            if (enabledBatchThreeExempt && !material.includes('%')) {
                return {
                    valid: false,
                    message: `第${rowIndex + 1}行：批3豁免钢铝铜要求材质填写百分比含量！`
                }
            }

            return { valid: true }
        },
        // 公共方法
        setOtherAmounts(item) {
            item.mpfAmount = (item.totalPrice * 0.003464).toFixed(2)
            if (this.mblType === 0) {
                item.hmfAmount = (item.totalPrice * 0.00125).toFixed(2) ?? 0
                item.totalAmount = (
                    parseFloat(item.dutyAmount) +
                    parseFloat(item.mpfAmount) +
                    parseFloat(item.hmfAmount)
                ).toFixed(2)
            } else {
                item.totalAmount = (
                    parseFloat(item.dutyAmount) + parseFloat(item.mpfAmount)
                ).toFixed(2)
                item.hmfAmount = 0
            }
            item.unitGrossAmount = item.netWeight > 0
                ? (parseFloat(item.totalAmount) / item.netWeight).toFixed(2)
                : 0
        },
        // 判断是否是 batchNo 系列字段
        isBatchField(filed) {
            const batchFields = [
                'batchNo',
                'batchNoTwo',
                'batchNoThree',
                'batchNoFour',
                'batchNoFive',
                'batchNoSix',
                'batchNoSeven',
                'batchNoEight'
            ]
            return batchFields.includes(filed)
        },

        // 获取豁免标志
        getExemptFlag(row, filed) {
            const exemptFlags = {
                batchNo: 'isAddRateExempt',
                batchNoTwo: 'isAddRateTwoExempt',
                batchNoThree: 'isAddRateThreeExempt',
                batchNoFour: 'isAddRateFourExempt',
                batchNoFive: 'isAddRateFiveExempt',
                batchNoSix: 'isAddRateSixExempt',
                batchNoSeven: 'isAddRateSevenExempt',
                batchNoEight: 'isAddRateEightExempt'
            }
            const flagKey = exemptFlags[filed]
            return row[flagKey] === true
        },

        // 获取显示值
        getBatchValue(row, filed) {
            const exemptFieldMap = {
                batchNo: 'batchNoExempt',
                batchNoTwo: 'batchNoTwoExempt',
                batchNoThree: 'batchNoThreeExempt',
                batchNoFour: 'batchNoFourExempt',
                batchNoFive: 'batchNoFiveExempt',
                batchNoSix: 'batchNoSixExempt',
                batchNoSeven: 'batchNoSevenExempt',
                batchNoEight: 'batchNoEightExempt'
            }
            const exemptField = exemptFieldMap[filed]
            return this.getExemptFlag(row, filed) ? row[exemptField] : row[filed]
        },
        beforeUpload(file) {
            if (this.fileList.length >= 5) {
                this.$message.error('最多上传5个文件')
                return false // 阻止上传
            }

            const suffix = file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase()
            const fileTypeArr = ['jpg', 'jpeg', 'png', 'pdf', 'doc']
            if (!fileTypeArr.includes(suffix)) {
                this.$message.error('只能上传（图片、pdf、doc类型的文件）请重新上传')
                return false // 阻止上传
            }

            // ✅ 不再这里 push！只返回 true 允许上传
            return true
        },
        onProgress(e) {
            this.fileList = this.fileList.map((a) => {
                return {
                    ...a,
                    percent: e.percent
                }
            })
        },
        handleSuccess(res, file) {
            // 从响应中解构你需要的数据
            const { fileGuid, filePath, fileName, fileSize, fileSuffix } = res.data

            // 把新文件信息添加到你的 fileList
            this.fileList.push({
                fileName: fileName,
                fileSize: fileSize || file.size,
                filePath: filePath,
                fileGuid: fileGuid,
                fileSuffix: fileSuffix
            })
        },
        filterSize(size) {
            return `${(size / (1024 * 1024)).toFixed(2)}`
        },
        deleteFile(index) {
            this.fileList.splice(index, 1)
        },
        review(item) {
            const suffix = item.fileName.slice(
                item.fileName.lastIndexOf('.') + 1,
                item.fileName.length
            )
            if (
                suffix.toLowerCase() === 'jpg' ||
                suffix.toLowerCase() === 'jpeg' ||
                suffix.toLowerCase() === 'png'
            ) {
                this.$viewerApi({
                    images: item.filePath
                })
            } else if (suffix.toLowerCase() === 'pdf') {
                window.open(
                    item.filePath
                )
            } else {
                this.$message.error('暂时只支持图片和PDF查看')
            }
        },
        getSummaries(param) {
            if (this.isOpt) {
                const { columns, data } = param
                const sums = []
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '总'
                        return
                    }
                    if (index === 1) {
                        sums[index] = '计：'
                        return
                    }
                    if (
                        index === 2 ||
                        index === 3 ||
                        index === 4 ||
                        index === 5 ||
                        index === 6 ||
                        index === 7 ||
                        index === 8 ||
                        index === 9 ||
                        index === 10 ||
                        index === 11 ||
                        index === 12 ||
                        index === 13 ||
                        index === 14 ||
                        index === 15 ||
                        index === 16 ||
                        index === 17 ||
                        index === 20 ||
                        index === 31 ||
                        index === 32 ||
                        (this.mblType !== 0 && index === 30)
                    ) {
                        sums[index] = ''
                        return
                    }
                    const values = data
                        .filter((a) => a.operationType !== 1)
                        .map((item) => Number(item[column.property]))
                    if (!values.every((value) => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr)
                            if (!isNaN(value)) {
                                return prev + curr
                            } else {
                                return prev
                            }
                        }, 0)
                        if (!(index === 18 || index === 19)) {
                            sums[index] = sums[index].toFixed(2)
                        }
                    } else {
                        sums[index] = ''
                    }
                })
                // 总杂费
                if (this.mblType === 0) {
                    // 列表MPF之和(每年10月1号 MPF费用调整)
                    let a = 0
                    const sumMPF = parseFloat(sums[28])
                    if (sumMPF < 33.58) a = 33.58
                    if (sumMPF > 33.58 && sumMPF < 651.50) { a = parseFloat(sumMPF.toFixed(2)) }
                    if (sumMPF > 651.50) a = 651.50

                    // 列表HMF之和
                    const sumHMF = parseFloat(sums[29])

                    // 总杂费=MPF+HMF;
                    let MPHMF = a + sumHMF
                    // 确保 MPHMF 是数字类型
                    MPHMF = parseFloat(MPHMF)
                    // 确保总杂费是数字类型
                    const b = MPHMF.toFixed(2)

                    this.incidentalsData = b
                    this.sumData = (parseFloat(b) + parseFloat(sums[27])).toFixed(2)
                } else {
                    const MPHMF = parseFloat(sums[28])
                    let a = 0
                    if (MPHMF < 33.58) a = 33.58
                    if (MPHMF > 33.58 && MPHMF < 651.50) a = parseFloat(MPHMF.toFixed(2))
                    if (MPHMF > 651.50) a = 651.50
                    this.incidentalsData = a
                    this.sumData = (parseFloat(a) + parseFloat(sums[27])).toFixed(2)
                }
                return sums
            } else {
                const { columns, data } = param
                const sums = []
                columns.forEach((column, index) => {
                    if (index === 0) {
                        sums[index] = '总'
                        return
                    }
                    if (index === 1) {
                        sums[index] = '计：'
                        return
                    }
                    if (
                        index === 2 ||
                        index === 3 ||
                        index === 4 ||
                        index === 5 ||
                        index === 6 ||
                        index === 7 ||
                        index === 8 ||
                        index === 9 ||
                        index === 10 ||
                        index === 11 ||
                        index === 12 ||
                        index === 13 ||
                        index === 14 ||
                        index === 15 ||
                        index === 16 ||
                        index === 19 ||
                        index === 30 ||
                        index === 31 ||
                        (this.mblType !== 0 && index === 29)
                    ) {
                        sums[index] = ''
                        return
                    }
                    const values = data
                        .filter((a) => a.operationType !== 1)
                        .map((item) => Number(item[column.property]))
                    if (!values.every((value) => isNaN(value))) {
                        sums[index] = values.reduce((prev, curr) => {
                            const value = Number(curr)
                            if (!isNaN(value)) {
                                return prev + curr
                            } else {
                                return prev
                            }
                        }, 0)
                        if (!(index === 17 || index === 18)) {
                            sums[index] = sums[index].toFixed(2)
                        }
                    } else {
                        sums[index] = ''
                    }
                })
                // 总税金---总杂费相关计算
                if (this.mblType === 0) {
                    // 列表MPF之和(每年10月1号 MPF费用调整)
                    let a = 0
                    const sumMPF = parseFloat(sums[27])
                    if (sumMPF < 33.58) a = 33.58
                    if (sumMPF > 33.58 && sumMPF < 651.50) { a = parseFloat(sumMPF.toFixed(2)) }
                    if (sumMPF > 651.50) a = 651.50

                    // 列表HMF之和
                    const sumHMF = parseFloat(sums[28])
                    // 总杂费=MPF+HMF;
                    let MPHMF = a + sumHMF
                    // 确保 MPHMF 是数字类型
                    MPHMF = parseFloat(MPHMF)
                    // 确保总杂费是数字类型
                    const b = MPHMF.toFixed(2)
                    this.incidentalsData = b
                    this.sumData = (parseFloat(b) + parseFloat(sums[26])).toFixed(2)
                } else {
                    const MPHMF = parseFloat(sums[27])
                    let a = 0
                    if (MPHMF < 33.58) a = 33.58
                    if (MPHMF > 33.58 && MPHMF < 651.50) a = parseFloat(MPHMF.toFixed(2))
                    if (MPHMF > 651.50) a = 651.50
                    // 总杂费
                    this.incidentalsData = a
                    // 总税金
                    this.sumData = (parseFloat(a) + parseFloat(sums[26])).toFixed(2)
                }
                return sums
            }
        },

        headerCellStyle({ columnIndex }) {
            if (
                (this.isOpt &&
                    (columnIndex === 6 ||
                        columnIndex === 7 ||
                        columnIndex === 8 ||
                        columnIndex === 9 ||
                        columnIndex === 10 ||
                        columnIndex === 11 ||
                        columnIndex === 12 ||
                        columnIndex === 13 ||
                        columnIndex === 14 ||
                        columnIndex === 15 ||
                        columnIndex === 21 ||
                        columnIndex === 26 ||
                        columnIndex === 27 ||
                        columnIndex === 28 ||
                        columnIndex === 29 ||
                        columnIndex === 30 ||
                        (this.mblType === 0 && columnIndex === 31))) ||
                (!this.isOpt &&
                    (columnIndex === 5 ||
                        columnIndex === 6 ||
                        columnIndex === 7 ||
                        columnIndex === 8 ||
                        columnIndex === 9 ||
                        columnIndex === 10 ||
                        columnIndex === 11 ||
                        columnIndex === 12 ||
                        columnIndex === 13 ||
                        columnIndex === 14 ||
                        columnIndex === 20 ||
                        columnIndex === 25 ||
                        columnIndex === 26 ||
                        columnIndex === 27 ||
                        columnIndex === 28 ||
                        columnIndex === 29 ||
                        (this.mblType === 0 && columnIndex === 30)))
            ) {
                return {
                    background: '#99DCC0 !important',
                    color: '#333333',
                    fontWeight: 'bold'
                }
            } else {
                return {
                    background: '#D2E9FC',
                    color: '#333333',
                    fontWeight: 'bold'
                }
            }
        },

        cellClassName({ row }) {
            if (!row.isEdit) {
                if (row.operationType === 1 || row.operationType === 0) {
                    if (this.isCoustomer) {
                        return 'add-coustomer-table-row'
                    } else {
                        return 'add-admin-table-row'
                    }
                }
                return this.isOpt && 'lock-table-row'
            }
        },

        cellStyle({ columnIndex, row }) {
            const isfArr = []
            if (this.rowData.isfHsCode !== undefined && this.rowData.isfHsCode !== '') {
                isfArr.push(this.rowData.isfHsCode?.split(';'))
                const w = isfArr.find((a) => a === row.hsCode)
                if (w !== undefined && columnIndex === 5) {
                    if (!row.isExists) {
                        return {
                            color: 'green'
                        }
                    } else {
                        return {
                            color: 'blue'
                        }
                    }
                }
            }
            if (!row.isExists) {
                if (this.isOpt && columnIndex === 5) {
                    return {
                        color: 'red'
                    }
                } else if (!this.isOpt && columnIndex === 4) {
                    return {
                        color: 'red'
                    }
                }
            }
            const editJson = row.editJson || []
            if (editJson.length > 0) {
                let deleteFlag = false
                if (row.operationType === 1) {
                    deleteFlag = true
                }
                let flag = false
                editJson.forEach((item) => {
                    const index = this.fileds.findIndex(
                        (filed) => filed.filed === item.feildName
                    )
                    if (index > 0) {
                        // 要有两个判断  修改的标记才不会出现位置错乱  一个是有多选的  一个没有多选的表格
                        if (
                            (this.isOpt && columnIndex === index + 2) ||
                            (!this.isOpt && columnIndex === index + 1 && index > -1)
                        ) {
                            flag = true
                        }
                    }
                })
                if (deleteFlag) {
                    return {
                        color: '#DCDFE6 !important'
                    }
                }
                if (flag) {
                    return {
                        background: this.isCoustomer ? '#FFE500' : '#35BA83'
                    }
                }
            }
            if (row.originCountry !== 'CN') {
                if (this.isOpt && columnIndex === 15) {
                    return {
                        color: 'red'
                    }
                } else if (!this.isOpt && columnIndex === 14) {
                    return {
                        color: 'red'
                    }
                }
            } else if (
                (this.isOpt &&
                    (columnIndex === 6 ||
                        columnIndex === 7 ||
                        columnIndex === 8 ||
                        columnIndex === 9 ||
                        columnIndex === 10 ||
                        columnIndex === 11 ||
                        columnIndex === 12 ||
                        columnIndex === 13 ||
                        columnIndex === 14 ||
                        columnIndex === 15 ||
                        columnIndex === 21 ||
                        columnIndex === 26 ||
                        columnIndex === 27 ||
                        columnIndex === 28 ||
                        columnIndex === 29 ||
                        columnIndex === 30 ||
                        (this.mblType === 0 && columnIndex === 31))) ||
                (!this.isOpt &&
                    (columnIndex === 5 ||
                        columnIndex === 6 ||
                        columnIndex === 7 ||
                        columnIndex === 8 ||
                        columnIndex === 9 ||
                        columnIndex === 10 ||
                        columnIndex === 11 ||
                        columnIndex === 12 ||
                        columnIndex === 13 ||
                        columnIndex === 14 ||
                        columnIndex === 20 ||
                        columnIndex === 25 ||
                        columnIndex === 26 ||
                        columnIndex === 27 ||
                        columnIndex === 28 ||
                        columnIndex === 29 ||
                        (this.mblType === 0 && columnIndex === 30)))
            ) {
                return {
                    background: '#E9F7F1'
                }
            }
        },

        getComponent(filed) {
            const numericFields = ['unitPrice', 'netWeight', 'grossWeight']
            return numericFields.includes(filed) ? 'el-input-number' : 'el-input'
        },

        getInputProps(filed) {
            const numericFields = ['netWeight', 'grossWeight']
            const numericFields1 = [
                'steelAluminiumValues',
                'steelAluminiumNetWeight'
            ]
            const numeric = ['unitPrice']
            if (numeric.includes(filed)) {
                return {
                    precision: 4, // 小数点后保留3位
                    step: 0.0001, // 步长
                    min: 0.0001, // 最小值
                    max: 9999999.9999, // 最大值
                    controlsPosition: 'right' // 控制按钮位置
                }
            } else if (numericFields.includes(filed)) {
                return {
                    precision: 2, // 小数点后保留3位
                    step: 0.01, // 步长
                    min: 0.01, // 最小值
                    max: 9999999.99, // 最大值
                    controlsPosition: 'right' // 控制按钮位置
                }
            } else if (numericFields1.includes(filed)) {
                return {
                    precision: 2, // 小数点后保留3位
                    step: 0.01, // 步长
                    min: 0, // 最小值
                    max: 9999999.99, // 最大值
                    controlsPosition: 'right' // 控制按钮位置
                }
            } else {
                return {}
            }
        },

        cellDblclick(row, column) {
            if (row.operationType === 1) {
                return
            }
            if (column.property === 'nameCH') {
                this.dialogVisible = true
            }
            if (column.property === 'hsCode') {
                this.dialogVisible2 = true
            }
        },

        // 👉 关闭所有行的编辑状态
        exitAllEdit() {
            this.productData.forEach((row) => {
                if (row.editFiled) {
                    this.$set(row, 'editFiled', null) // 使用 $set 确保响应式
                }
            })
        },

        cellclick(row, column) {
            if (row.operationType === 1) {
                return
            }
            const editFiled = [
                'nameEN',
                'nameCH',
                'material',
                'usedFor',
                'packages',
                'qty',
                'unitPrice',
                'netWeight',
                'grossWeight',
                'steelAluminiumValues',
                'steelAluminiumNetWeight',
                'mark',
                'optimizationRemark'
            ]
            if (!row.isEdit) {
                this.$message.warning('当前行不可编辑，请解锁编辑')
                return false
            }
            this.editData = row[column.property]
            this.selectRow = row
            if (editFiled.includes(column.property)) {
                // 🔚 先关闭所有其他编辑
                this.exitAllEdit()

                // ✅ 再开启当前编辑
                this.$set(row, 'editFiled', column.property)
            }
        },

        /**
         * 校验单行数据
         * @param {Object} row 行数据
         * @param {Number} index 行索引（用于错误提示）
         * @returns {{ valid: boolean, message: string | null }}
         */
        validateRow(row, index) {
            const hasValue = (val) => val != null && val !== ''
            const rowIndex = index + 1

            // 基础数值校验
            if (+row.netWeight > +row.grossWeight) {
                return { valid: false, message: `第${rowIndex}行：净重不能大于毛重！` }
            }
            if (+row.steelAluminiumNetWeight > +row.netWeight) {
                return { valid: false, message: `第${rowIndex}行：钢铝铜净重不能大于净重！` }
            }
            if (+row.steelAluminiumValues > +row.totalPrice) {
                return { valid: false, message: `第${rowIndex}行：钢铝铜值不能大于总价！` }
            }

            // === 新增：批次3（Batch 3）材质校验逻辑 ===
            const materialResult = this.validateMaterial(row, index)
            if (!materialResult.valid) {
                return materialResult
            }

            // ✅ 强制校验8：：如果申报轻型汽配批次那么中&重型汽配批次必须有豁免批次信息
            // 规则1：存在 batchNoFive 且batchNoFiveExempt 为空，则batchNoEightExempt 必须有值
            if (
                hasValue(row.batchNoFive) &&
                !hasValue(row.batchNoFiveExempt) &&
                hasValue(row.batchNoEight)
            ) {
                if (!hasValue(row.batchNoEightExempt)) {
                    return {
                        valid: false,
                        message: `第${rowIndex}行：申报了轻型汽配和中&重型卡车及汽配批次，但【中&重型卡车及汽配豁免批次】为空！！！`
                    }
                }
            }

            // ✅ 校验通过
            return { valid: true, message: null }
        },

        /**
       * 编辑字段时触发校验（带提示）
       */
        filedChange(row) {
            if (this.isShowingError) return // 防止重复弹窗
            const rowIndex = this.invoiceData.indexOf(row)
            const result = this.validateRow(row, rowIndex)

            if (!result.valid) {
                this.isShowingError = true
                this.$message.error(result.message) // 只提示一次
                // 2秒后允许再次提示（避免长时间锁死）
                setTimeout(() => {
                    this.isShowingError = false
                }, 2000)
            }
        },

        productOk(item) {
            this.dialogVisible = false
            const row = this.productData.find((a) => a.id === this.selectRow.id)
            this.$store.commit(
                'set_loop_item',
                JSON.parse(JSON.stringify([...this.productData]))
            )
            row.nameEN = item.nameEN
            row.nameCH = item.nameCH
            row.hsCode = item.hsCode
            row.batchNo = item.batchNo
            row.batchNoTwo = item.batchNoTwo
            row.batchNoThree = item.batchNoThree
            row.batchNoFour = item.batchNoFour
            row.batchNoFive = item.batchNoFive
            row.batchNoSix = item.batchNoSix
            row.batchNoSeven = item.batchNoSeven
            row.batchNoEight = item.batchNoEight
            row.material = item.material
            row.usedFor = item.used
            row.baseRateWeight = item.baseRateWeight
            row.baseRateQuantity = item.baseRateQuantity
            row.addRate = item.addRate
            row.addRateTwo = item.addRateTwo
            row.addRateThree = item.addRateThree
            row.addRateFour = item.addRateFour
            row.addRateFive = item.addRateFive
            row.addRateSix = item.addRateSix
            row.addRateSeven = item.addRateSeven
            row.addRateEight = item.addRateEight
            row.baseRate = item.baseRate
            row.isAluminumLicense = item.isAluminumLicense
            row.isSteelLicense = item.isSteelLicense
            row.isAddRateExempt = item.isAddRateExempt
            row.isAddRateTwoExempt = item.isAddRateTwoExempt
            row.isAddRateThreeExempt = item.isAddRateThreeExempt
            row.isAddRateFourExempt = item.isAddRateFourExempt
            row.isAddRateFiveExempt = item.isAddRateFiveExempt
            row.isAddRateSixExempt = item.isAddRateSixExempt
            row.isAddRateSevenExempt = item.isAddRateSevenExempt
            row.isAddRateEightExempt = item.isAddRateEightExempt
            row.originCountry = item.originCountry
            row.isExists = true
            row.mblProductId = 0
        },

        taxOk(item) {
            const hasValue = (val) => val != null && val !== ''
            this.dialogVisible2 = false
            const row = this.productData.find((a) => a.id === this.selectRow.id)
            this.$store.commit(
                'set_loop_item',
                JSON.parse(JSON.stringify([...this.productData]))
            )
            row.hsCode = item.hsCode
            row.batchNo = item.batchNo
            row.batchNoTwo = item.batchNoTwo
            row.batchNoThree = item.batchNoThree
            row.batchNoFour = item.batchNoFour
            row.batchNoFive = item.batchNoFive
            row.batchNoSix = item.batchNoSix
            row.batchNoSeven = item.batchNoSeven
            row.batchNoEight = item.batchNoEight
            row.baseRateWeight = item.baseRateWeight
            row.baseRateQuantity = item.baseRateQuantity
            row.addRate = item.addRate
            row.addRateTwo = item.addRateTwo
            row.addRateThree = item.addRateThree
            row.addRateFour = item.addRateFour
            row.addRateFive = item.addRateFive
            row.addRateSix = item.addRateSix
            row.addRateSeven = item.addRateSeven
            row.addRateEight = item.addRateEight
            row.baseRate = item.baseRate
            row.isAluminumLicense = item.isAluminumLicense
            row.isSteelLicense = item.isSteelLicense
            row.originCountry = item.originCountry
            row.batchNoExempt = item.batchNoExempt
            row.batchNoTwoExempt = item.batchNoTwoExempt
            row.batchNoThreeExempt = item.batchNoThreeExempt
            row.batchNoFourExempt = item.batchNoFourExempt
            row.batchNoFiveExempt = item.batchNoFiveExempt
            row.batchNoSixExempt = item.batchNoSixExempt
            row.batchNoSevenExempt = item.batchNoSevenExempt
            row.batchNoEightExempt = item.batchNoEightExempt

            row.isAddRateExempt = hasValue(item.batchNoExempt)
            row.isAddRateTwoExempt = hasValue(item.batchNoTwoExempt)
            row.isAddRateThreeExempt = hasValue(item.batchNoThreeExempt)
            row.isAddRateFourExempt = hasValue(item.batchNoFourExempt)
            row.isAddRateFiveExempt = hasValue(item.batchNoFiveExempt)
            row.isAddRateSixExempt = hasValue(item.batchNoSixExempt)
            row.isAddRateSevenExempt = hasValue(item.batchNoSevenExempt)
            row.isAddRateEightExempt = hasValue(item.batchNoEightExempt)
            row.isExists = true
            // 强制替换整个 productData 数组（触发响应式更新）
            this.productData = [...this.productData]
        },

        selectionchange(selections) {
            this.selections = selections
        },

        merge() {
            if (this.selections.length < 2) {
                this.$message.error('请选择至少2条数据')
                return
            }
            this.dialogVisible3 = true
        },

        async insertMetal(type) {
            if (this.selections.length < 1) {
                this.$message.error('请选择至少1条数据')
                return
            }

            // 🔍 前置校验：根据 type 执行不同校验
            let invalidItems = []
            const typeConfig = {
                0: { field: 'batchNoThree', name: '批次3', desc: '豁免钢铝' },
                2: { field: 'batchNoFive', name: '批次5', desc: '豁免轻型汽配' },
                3: { field: 'batchNoSeven', name: '批次7', desc: '豁免木制' },
                4: { field: 'batchNo', name: '批次1', desc: '豁免301' },
                5: { field: 'batchNoEight', name: '批次8', desc: '豁免中&重型卡车及配件' },
                6: { field: 'batchNoTwo', name: '批次2', desc: '豁免122' },
                11: { field: 'batchNoTwo', name: '批次2', desc: '申报122' }
            }

            // 校验：申报122 要求 batchNoTwo 已设置且不为空
            if (type === 11) {
                invalidItems = this.selections.filter(
                    item => !item.batchNoTwo || item.batchNoTwo.trim() === ''
                )
                if (invalidItems.length > 0) {
                    const names = invalidItems.map(item => item.nameCH || item.hsCode).join('、')
                    this.$alert(
                        `以下产品【批次2】为空，无法进行申报122操作<br><strong>${names}</strong>`,
                        '数据校验不通过',
                        {
                            type: 'error',
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: '确定'
                        }
                    )
                    return
                }
            }

            // 校验：豁免122 要求 batchNoThree~batchNoEight 不为空且豁免信息不为空
            if (type === 6) {
                invalidItems = this.selections.filter(item => {
                    const fields = ['batchNoThree', 'batchNoFour', 'batchNoFive', 'batchNoSix', 'batchNoSeven', 'batchNoEight']
                    return fields.every(field => {
                        const val = item[field]
                        return val === null || val === undefined || (typeof val === 'string' && val.trim() === '')
                    })
                })
                if (invalidItems.length > 0) {
                    const names = invalidItems.map(item => item.nameCH || item.hsCode).join('、')
                    this.$alert(
                        `以下产品【批次3-8】为空，无法进行豁免122操作<br><strong>${names}</strong>`,
                        '数据校验不通过',
                        {
                            type: 'error',
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: '确定'
                        }
                    )
                    return
                }
            }

            // 校验：其他类型（如钢铝、铜等）检查对应字段
            if (typeConfig[type]) {
                const { field, name, desc } = typeConfig[type]
                invalidItems = this.selections.filter(
                    item => !item[field] || item[field].trim() === ''
                )

                if (invalidItems.length > 0) {
                    const names = invalidItems.map(item => item.nameCH || item.hsCode).join('、')
                    this.$alert(
                        `以下产品【${name}】为空，无法${desc}添加122附加税<br><strong>${names}</strong>`,
                        '数据校验不通过',
                        {
                            type: 'error',
                            dangerouslyUseHTMLString: true,
                            confirmButtonText: '确定'
                        }
                    )
                    return
                }
            }

            // ✅ 保存当前状态（用于撤销）
            this.$store.commit(
                'set_loop_item',
                JSON.parse(JSON.stringify([...this.productData]))
            )
            // 🔔 特殊处理 type === 0：使用自定义弹窗
            if (type === 0) {
                this.showCopperDialog = true
                return
            }

            // 🔔 确认对话框
            try {
                await this.$confirm(
                    `确定要为选中的 ${this.selections.length} 条数据添加122附加税吗？`,
                    '添加附加税',
                    {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                        closeOnClickModal: false,
                        lockScroll: true
                    }
                )
            } catch {
                return // 用户取消
            }
            await this.callInsertMetalApi(0, '')
        },

        // 新增：铜豁免确认后的处理
        async confirmCopperAction() {
            this.showCopperDialog = false
            // 调用 API，并传入用户选择的豁免码
            await this.callInsertMetalApi(0, this.batchNoThreeExempt)
        },

        // 新增：统一 API 调用方法
        async callInsertMetalApi(type) {
            try {
                // const params = {
                //     list: this.selections,
                //     metalType: type,
                //     batchNoThreeExempt: batchNoThreeExempt // 只有 type=1 时有值
                // }

                const res = '' // await insertMetalList(params)

                if (res.success) {
                    // ========== 【核心修复：直接操作 productData 真实引用】 ==========
                    res.data.forEach(returnedItem => {
                        // 精准定位 productData 中的真实对象（非 selections 副本）
                        const targetIndex = this.productData.findIndex(p =>
                            p.hsCode === returnedItem.hsCode &&
                            p.nameCH === returnedItem.nameCH
                        )

                        if (targetIndex === -1) {
                            console.warn(`[警告] 未在 productData 中找到匹配项: ${returnedItem.hsCode}_${returnedItem.nameCH}`)
                            return
                        }

                        // 创建新对象（保留所有原有属性 + 更新新值）
                        const updatedItem = {
                            ...this.productData[targetIndex], // 保留所有原有属性

                            // 通用字段（所有 type 共享）
                            batchNoTwo: returnedItem.batchNoTwo || '',
                            addRateTwo: returnedItem.addRateTwo || 0,
                            batchNoTwoExempt: returnedItem.batchNoTwoExempt || '', // ✅ 关键修复
                            createdOn: returnedItem.createdOn,
                            createdName: returnedItem.createdName,
                            isExists: true,

                            // 豁免状态（统一设置）
                            isAddRateExempt: !!returnedItem.batchNoExempt,
                            isAddRateTwoExempt: !!returnedItem.batchNoTwoExempt,
                            isAddRateThreeExempt: !!returnedItem.batchNoThreeExempt,
                            isAddRateFourExempt: !!returnedItem.batchNoFourExempt,
                            isAddRateFiveExempt: !!returnedItem.batchNoFiveExempt,
                            isAddRateSixExempt: !!returnedItem.batchNoSixExempt,
                            isAddRateSevenExempt: !!returnedItem.batchNoSevenExempt,
                            isAddRateEightExempt: !!returnedItem.batchNoEightExempt
                        }

                        // 按 type 补充特有字段
                        switch (type) {
                            case 0: // 钢铝
                                Object.assign(updatedItem, {
                                    batchNoThree: returnedItem.batchNoThree || '',
                                    addRateThree: returnedItem.addRateThree || 0,
                                    batchNoThreeExempt: returnedItem.batchNoThreeExempt || ''
                                })
                                break
                            case 1: // 铜
                                Object.assign(updatedItem, {
                                    batchNoSix: returnedItem.batchNoSix || '',
                                    addRateSix: returnedItem.addRateSix || 0,
                                    batchNoSixExempt: returnedItem.batchNoSixExempt || ''
                                })
                                break
                            case 2: // 轻型汽配
                                Object.assign(updatedItem, {
                                    batchNoFive: returnedItem.batchNoFive || '',
                                    addRateFive: returnedItem.addRateFive || 0,
                                    batchNoFiveExempt: returnedItem.batchNoFiveExempt || ''
                                })
                                break
                            case 3: // 木制
                                Object.assign(updatedItem, {
                                    batchNoSeven: returnedItem.batchNoSeven || '',
                                    addRateSeven: returnedItem.addRateSeven || 0,
                                    batchNoSevenExempt: returnedItem.batchNoSevenExempt || ''
                                })
                                break
                            case 4: // 301
                                Object.assign(updatedItem, {
                                    batchNo: returnedItem.batchNo || '',
                                    addRate: returnedItem.addRate || 0,
                                    batchNoExempt: returnedItem.batchNoExempt || ''
                                })
                                break
                            case 5: // 中重型卡车
                                Object.assign(updatedItem, {
                                    batchNoEight: returnedItem.batchNoEight || '',
                                    addRateEight: returnedItem.addRateEight || 0,
                                    batchNoEightExempt: returnedItem.batchNoEightExempt || ''
                                })
                                break
                            case 6: // 豁免122
                                Object.assign(updatedItem, {
                                    batchNoTwoExempt: returnedItem.batchNoTwoExempt || '99030302',
                                    addRateTwo: returnedItem.addRateTwo || 10,
                                    batchNoTwo: returnedItem.batchNoTwo || '99030301'
                                })
                                break
                            case 11: // 申报122
                                Object.assign(updatedItem, {
                                    batchNoTwoExempt: returnedItem.batchNoTwoExempt || null,
                                    addRateTwo: returnedItem.addRateTwo || 10,
                                    batchNoTwo: returnedItem.batchNoTwo || '99030301',

                                    // 清空批次3-8相关字段
                                    batchNoThree: null,
                                    addRateThree: 0,
                                    batchNoThreeExempt: null,

                                    batchNoFour: null,
                                    addRateFour: 0,
                                    batchNoFourExempt: null,

                                    batchNoFive: null,
                                    addRateFive: 0,
                                    batchNoFiveExempt: null,

                                    batchNoSix: null,
                                    addRateSix: 0,
                                    batchNoSixExempt: null,

                                    batchNoSeven: null,
                                    addRateSeven: 0,
                                    batchNoSevenExempt: null,

                                    batchNoEight: null,
                                    addRateEight: 0,
                                    batchNoEightExempt: null
                                })
                                break
                            default:
                                // 保持不变
                                break
                        }

                        // ✅ 【关键】使用 Vue.set 替换整个对象（确保响应式更新）
                        this.$set(this.productData, targetIndex, updatedItem)
                    })

                    // 清空选择
                    this.selections = []
                    this.$message.success('添加成功')
                } else {
                    this.$message.error(res.errorMessage || '操作失败')
                }
            } catch (error) {
                console.error('API 调用异常:', error)
                this.$message.error(error.message || '网络请求失败')
            }
        },

        mergeOk(item) {
            this.$store.commit(
                'set_loop_item',
                JSON.parse(JSON.stringify([...this.productData]))
            )
            const dataIndex = this.productData.findIndex(
                (a) => a === this.selections[0]
            )
            this.selections.forEach((product) => {
                const index = this.productData.findIndex((a) => a === product)
                this.productData.splice(index, 1)
            })
            this.productData.splice(dataIndex, 0, item)
            this.dialogVisible3 = false
        },

        deleteRow() {
            if (!this.selections.length) {
                this.$message.error('请选择至少1条数据')
                return
            }
            this.$store.commit(
                'set_loop_item',
                JSON.parse(JSON.stringify([...this.productData]))
            )
            this.selections.forEach((product) => {
                const index = this.productData.findIndex((a) => a === product)
                this.productData.splice(index, 1)
            })
        },

        addRow() {
            this.dialogVisible4 = true
        },

        addOk(item) {
            this.$store.commit(
                'set_loop_item',
                JSON.parse(JSON.stringify([...this.productData]))
            )
            this.productData.push({
                ...item,
                isEdit: true,
                mblId: this.rowData.mblId
            })
            this.dialogVisible4 = false
        },

        editRow() {
            if (!this.selections.length) {
                this.$message.error('请选择至少1条数据')
                return
            }
            this.selections.forEach((product) => {
                product.isEdit = true
            })
        },

        uneditRow() {
            if (!this.selections.length) {
                this.$message.error('请选择至少1条数据')
                return
            }
            this.$store.commit(
                'set_loop_item',
                JSON.parse(JSON.stringify([...this.productData]))
            )
            this.selections.forEach((product) => {
                product.isEdit = false
            })
        },

        prev() {
            const cachesArr = this.$store.state?.caches
            if (cachesArr.length === 1) {
                this.productData = JSON.parse(JSON.stringify(this.oldData))
            } else {
                cachesArr.length &&
                    (this.productData = JSON.parse(
                        JSON.stringify(cachesArr[cachesArr.length - 1])
                    ))
            }
            this.$store.commit('reduce_loop_item')
        },

        formatterData() {
            const arr = []
            this.productData.forEach((product) => {
                if (product.operationType !== 1) {
                    if (!product.id) {
                        product.operationType = 0 // 0 = Add(添加), 1 = Delete(删除), 2 = Edit(修改)
                        arr.push(product)
                    } else {
                        const oldData = this.oldData.find((item) => item.id === product.id)
                        if (oldData) {
                            if (JSON.stringify(oldData) === JSON.stringify(product)) {
                                arr.push(product)
                            } else {
                                product.operationType = 2
                                arr.push(product)
                            }
                        } else {
                            product.operationType = 0 // 0 = Add(添加), 1 = Delete(删除), 2 = Edit(修改)
                            arr.push(product)
                        }
                    }
                }
            })
            this.oldData
                .filter((a) => !this.productData.find((b) => a.id === b.id))
                .forEach((item) => {
                    // 被删除的
                    item.operationType = 1
                    arr.push(item)
                })
            return arr
        },

        xccancer() {
            sessionStorage.removeItem(`invoiceSave-${this.rowData.mblId}`)
            this.$message.success('清除成功')
            this.$emit('ok')
        },

        async restore() {
            this.loading = true
            try {
                const res = await restoreVersion(this.controlOverInvoicesId)
                if (res.success) {
                    this.$message.success('还原成功')
                    this.$emit('ok')
                    sessionStorage.removeItem(`invoiceSave-${this.rowData.mblId}`)
                    sessionStorage.removeItem(`adviceSave-${this.controlOverInvoicesId}`)
                    this.$store.commit('set_empty_item')
                } else {
                    this.$message.error(res.errorMessage)
                }
            } catch (error) {
                // 处理错误情况
                console.error('Error fetching options:', error)
            }
            this.loading = false
        },

        save() {
            this.loading = true
            sessionStorage.setItem(
                `invoiceSave-${this.rowData.mblId}`,
                JSON.stringify({
                    invoicedata: this.productData,
                    invoiceid: this.rowData.mblId
                })
            )
            this.$message.success('暂存成功')
            this.invoiceSave = this.productData
            this.loading = false
        },

        advicesave() {
            this.loading = true
            sessionStorage.setItem(
                `adviceSave-${this.controlOverInvoicesId}`,
                JSON.stringify({
                    advice: this.form.advice
                })
            )
            this.$message.success('暂存审单反馈建议成功')
            this.loading = false
            this.sdfkdialogVisible = false
        },

        selectable(row) {
            return row.operationType !== 1
        },

        cancel() {
            this.$store.commit('set_empty_item')
            this.$emit('close')
        },
        async determineok() {
            this.loading = true
            if (this.totalQty !== this.rowData.qty) {
                this.loading = false
                return this.$message.error('Ctns总数须与提单件数一致')
            }
            if (this.totalWeight !== this.rowData.weightKgs) {
                const { weightKgs } = this.rowData.weightKgs
                const total = this.totalWeight

                if (total < weightKgs * 0.99 || total > weightKgs * 1.01) {
                    this.loading = false
                    return this.$message.error('Gro.W总数须与提单重量一致（允许±1%误差）')
                }
            }

            const params = {
                mblId: this.rowData.mblId ?? this.rowData.id,
                mblType: this.mblType,
                newlist: this.productData.filter((a) => a.operationType !== 1),
                editSource: 1
            }
            console.log('审核通过参数：', params)
            // 使用新的统一校验
            const materialError = params.newlist.find((row, index) => !this.validateMaterial(row, index).valid)
            if (materialError) {
                this.loading = false
                this.$message.error(this.validateMaterial(materialError, params.newlist.indexOf(materialError)).message)
                return
            }
            const res = await systemInvoicePassForAdmin(params)
            if (res.success) {
                this.$message.success('审核通过')
                this.$emit('ok', 'ToBeDispatched')
                sessionStorage.removeItem(`invoiceSave-${this.rowData.mblId}`)
                this.$store.commit('set_empty_item')
            } else {
                this.loading = false
                return this.$message.error(res.errorMessage)
            }
            this.loading = false
        },

        sdfk() {
            this.sdfkdialogVisible = true
            const adviceJson = JSON.parse(
                sessionStorage.getItem(`adviceSave-${this.controlOverInvoicesId}`)
            )
            if (adviceJson) {
                this.form.advice = adviceJson.advice
            }
        },
        sdfkcancer() {
            this.sdfkdialogVisible = false
            this.fileList = []
        },
        async ok() {
            this.$refs.form.validate(async(valid) => {
                if (valid) {
                    this.loading = true
                    if (this.totalQty !== this.rowData.qty) {
                        this.loading = false
                        return this.$message.error('Ctns总数须与提单件数一致')
                    }
                    if (this.totalWeight !== this.rowData.weightKgs) {
                        const { weightKgs } = this.rowData.weightKgs
                        const total = this.totalWeight

                        if (total < weightKgs * 0.99 || total > weightKgs * 1.01) {
                            this.loading = false
                            return this.$message.error('Gro.W总数须与提单重量一致（允许±1%误差）')
                        }
                    }
                    const params = {
                        controlOverInvoicesId: this.controlOverInvoicesId,
                        mblId: this.rowData.mblId ?? this.rowData.id,
                        newlist: this.productData.filter((a) => a.operationType !== 1),
                        advice: this.form.advice,
                        fileData: this.fileList,
                        editSource: 1
                    }
                    // 使用新的统一校验
                    const materialError = params.newlist.find((row, index) => !this.validateMaterial(row, index).valid)
                    if (materialError) {
                        this.loading = false
                        this.$message.error(this.validateMaterial(materialError, params.newlist.indexOf(materialError)).message)
                        return
                    }
                    const res = await reviewFeedbackForAdmin(params)
                    try {
                        if (res.success) {
                            this.$message.success('审单反馈提交成功')
                            this.sdfkdialogVisible = false
                            this.$emit('ok', 'PendingReview')
                            sessionStorage.removeItem(`invoiceSave-${this.rowData.mblId}`)
                            this.$store.commit('set_empty_item')
                        } else {
                            if (
                                res.data.errorMessage.includes(
                                    'required for an e-mail address'
                                )
                            ) {
                                this.$message.error(
                                    '提单所属客户的预警邮箱格式异常，请检查！！！'
                                )
                            } else {
                                this.$message.error('接口请求失败' + res.data.errorMessage)
                            }
                        }
                    } catch (error) {
                        this.$message.error('异常原因：' + res.errorMessage)
                    } finally {
                        this.loading = false
                    }
                } else {
                    this.loading = false
                    return false
                }
                this.loading = false
            })
        },
        /**
 * 处理导出按钮点击
 */
        async exportInvoice() {
            const params = {
                mblNo: this.rowData.mblNo,
                list: this.productData.filter((a) => a.operationType !== 1)
            }

            this.loading = true
            try {
                await derive('ControlOverInvoices/exportInvoice', 'post', params, null)
            } catch (error) {
                console.error('Export error:', error)
                this.$message.error('导出失败')
            } finally {
                this.loading = false
            }
        },
        bgColor(item) {
            if (item.operationType === 1) {
                return 'delete-row'
            } else {
                if (this.isCoustomer) {
                    return 'add-customer-row'
                } else {
                    return 'add-admin-row'
                }
            }
        },
        formatHistory(arr, item) {
            if (!Array.isArray(arr)) return
            return arr?.find((a) => a.feildName === item.filed)
        },
        ifHisTory(arr, filed) {
            if (!Array.isArray(arr)) return false
            return arr.findIndex((a) => a.feildName === filed) > -1
        }
    }
}
</script>

<style scoped>
.invoice-table {
    padding-top: 12px;
    width: 100%;
    height: auto;

    .label-container {
        width: 100%;
        height: 30px;
        margin-bottom: 15px;
        display: flex;
        justify-content: center;
        position: relative;

        .back {
            position: absolute;
            width: 50px;
            height: 30px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #142e79;
            line-height: 30px;
            left: 0;
            cursor: pointer;

            img {
                vertical-align: text-top;
            }
        }

        .tips {
            position: absolute;
            left: 0;
            padding: 6px 0 0 5px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 13px;
            color: #142e79;

            .green {
                width: 8px;
                height: 8px;
                background: #ffe500;
                border-radius: 50%;
                display: inline-block;
            }

            .red {
                width: 8px;
                height: 8px;
                background: #35ba83;
                border-radius: 50%;
                margin-left: 20px;
                display: inline-block;
            }
        }

        .label-item {
            display: flex;

            &+.label-item {
                margin-left: 8px;
            }
        }

        .showTax {
            margin-left: 10px;
            width: auto;
            height: 30px;
            background: rgba(165, 90, 248, 0.1);
            border-radius: 16px 16px 16px 16px;
            display: flex;
            justify-content: space-between;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #a55af8;
            line-height: 30px;
            text-indent: 12px;

            .num {
                font-weight: bold;
                font-size: 18px;
                margin-right: 6px;
            }
        }

        .label-mark {
            width: 60px;
            height: 30px;
            background: #f7f7f7;
            border-radius: 4px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #142e79;
            line-height: 30px;
            text-align: center;
        }

        .label-info {
            width: auto;
            height: 30px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 14px;
            color: #333333;
            line-height: 30px;
            margin-left: 8px;
        }
    }

    .invoice-table-container {
        .el-table .cell {
            padding: 0;
        }

        :deep(.serialNumber .cell) {
            padding: 0;
        }

        .row-tips {
            position: absolute;
            top: 0;
            left: 0;
            display: inline-block;
            border-radius: 0px 0px 6px 0px;
            height: 12px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 12px;
            color: #ffffff;
            line-height: 12px;
            padding: 0 9px;
        }

        .delete-row {
            background: #fe453d;
            color: #DCDFE6 !important;
        }

        .add-customer-row {
            background: #c9b822;
        }

        .add-admin-row {
            background: #35ba83;
        }

        .doubleClick {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 10px;
            margin-left: 3px;

            .icon {
                width: 42px;
            }
        }

        .history {
            position: absolute;
            right: 10px;
            top: 50%;
            transform: translateY(-50%);
        }
    }

    .bottom {
        width: 100%;
        height: 65px;
        margin-top: 6px;
        padding-top: 6px;
        display: flex;
        justify-content: center;
        position: relative;

        .btn {
            width: 100px;
            height: 40px;
            cursor: pointer;
            text-align: center;
            border-radius: 4px;

            &+.btn {
                margin-left: 12px;
            }
        }

        .prev {
            border: 1px solid #dcdfe6;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #666666;
            margin-left: 280px;
            border-radius: 4px 4px 4px 4px;
        }

        .export {
            background: #edeeef;
            color: rgb(45, 46, 47);
            margin-left: 60px;
            border-radius: 4px 4px 4px 4px;
        }

        .cance {
            background: #dcdfe6;
            border-radius: 4px 4px 4px 4px;
        }

        .restore {
            background: rgb(199, 218, 222);
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #7683a9;
        }

        .save {
            background: #ffffff;
            border-radius: 4px 4px 4px 4px;
            border: 1px solid #142e79;
        }

        .ok {
            background: #142e79;
            color: #ffffff;
            border-radius: 4px 4px 4px 4px;
        }

        .footer {
            position: absolute;
            bottom: 0;
            padding: 0 4px;
            left: 0;
            width: 700px;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            /* 垂直居中 */
            gap: 6px;
            /* 统一间距，比原来更舒适 */
            font-family: Microsoft YaHei, sans-serif;
            font-size: 14px;
            color: #999999;
            line-height: 1;
            min-height: 70px;
            /* min-height: 30px; */
            /* 保证最小高度，避免塌陷 */

            /* 换行占位符 */
            .break {
                flex-basis: 100%;
                height: 0;
            }

            /* 文字计数部分 */
            span {
                white-space: nowrap;
                /* 防止“已选择 X 项”被拆行 */
                color: #999999;
                font-size: 14px;
                line-height: 28px;
            }

            .length {
                color: #142e79;
                font-weight: bold;
            }
        }

        .footer .btn1,
        .footer .btn2 {
            /* 统一基础样式 */
            display: inline-flex;
            align-items: center;
            justify-content: center;
            height: 28px;
            min-width: 65px;
            padding: 0 4px;
            border: 1px solid #dcdfe6;
            border-radius: 4px;
            font-family: Microsoft YaHei, sans-serif;
            color: #333;
            background: #ffffff;
            cursor: pointer;
            line-height: 1;
            text-align: center;
            transition: all 0.2s ease;
            white-space: nowrap;
            /* 防止文本换行 */
        }

        /* 悬停效果 */
        .footer .btn1:hover,
        .footer .btn2:hover {
            background: #f5f7fa;
            border-color: #bbb;
            transform: translateY(-1px);
        }

        /* 合并、删除、新增行 */
        .footer .btn1[style*="merge"],
        .footer .btn1[style*="deleteRow"],
        .footer .btn1[style*="addRow"] {
            width: auto;
            min-width: 65px;
        }

        /* 整单豁免半导体 */
        .footer .btn2 {
            min-width: 65px;
            padding: 0 4px;
        }

        /* 豁免301 */
        .footer .Tariffs301 {
            min-width: 65px;
            padding: 0 4px;
            border-color: #74c6a2;
            color: #74c6a2;
        }

        /* 申报301 */
        .footer .Declare122 {
            min-width: 65px;
            padding: 0 4px;
            border-color: #3a9ec9;
            color: #3a9ec9;
        }

        /* 豁免122 */
        .footer .Tariffs122 {
            min-width: 65px;
            padding: 0 4px;
            border-color: #423169;
            color: #423169;
        }

        /* 豁免钢铝 */
        .footer .SteelAndAluminum {
            min-width: 65px;
            padding: 0 4px;
            border-color: #1c1a1a;
            color: #1c1a1a;
        }

        /* 豁免汽配 */
        .footer .AutoParts {
            min-width: 65px;
            padding: 0 4px;
            border-color: #cc49e6;
            color: #cc49e6;
        }

        /* 豁免木制 */
        .footer .WoodTariffs {
            min-width: 65px;
            padding: 0 4px;
            border-color: #956106;
            color: #956106;
        }

        /* 豁免铜 */
        .footer .copper {
            min-width: 65px;
            padding: 0 4px;
            border-color: rgb(215, 215, 34);
            color: rgb(168, 168, 9);
        }

        /* 豁免中&重型卡车配件 */
        .footer .TruckPartsTariffs {
            min-width: 65px;
            padding: 0 4px;
            border-color: rgb(54, 9, 232);
            color: rgb(54, 9, 232);
        }

        /* 可编辑 / 不可编辑 */
        .footer .edit {
            min-width: 65px;
            padding: 0 4px;
            border-color: #2395f3;
            color: #2395f3;
        }

        .footer .unedit {
            min-width: 65px;
            padding: 0 4px;
            border-color: #fe453d;
            color: #fe453d;
        }

        .footer img {
            width: 15px;
            height: 14px;
            vertical-align: middle;
            /* 居中对齐 */
        }
    }
}

.disabled {
    pointer-events: none;
    /* 阻止鼠标事件 */
    opacity: 0.5;
    /* 降低透明度 */
    cursor: not-allowed;
    /* 显示禁止的鼠标光标 */
}

.exportbutton {
    margin-left: 30px;
    background: rgba(90, 153, 248, 0.1);
    justify-content: space-between;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #2395f3;
}

:deep(.el-upload-dragger) {
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 580px;
    height: 100px;
    text-align: center;
    cursor: pointer;
    overflow: hidden;
}

.fileList {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    width: 580px;
    margin-left: 0px;

    .fileItem {
        display: flex;
        align-self: flex-end;
        padding: 0 10px;
        background: #ffffff;
        border-radius: 4px 4px 4px 4px;
        box-shadow: 0px 0px 4px 0px rgba(20, 46, 121, 0.2);
        width: 282px;
        height: 46px;
        box-sizing: border-box;
        margin-bottom: 12px;
    }

    .left {
        display: flex;
        width: 280px;
    }

    .file {
        display: flex;
        flex-direction: column;
        margin-left: 2px;
        overflow: hidden;
    }

    .fileName {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .fileSize {
        height: 20px;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        line-height: 20px;
        margin-top: 5px;
    }

    .uploadType {
        display: flex;
        align-items: center;
        width: auto;
        height: 16px;
        background: rgba(35, 149, 243, 0.1);
        border-radius: 4px 4px 4px 4px;
        padding: 0 10px;
        box-sizing: border-box;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 12px;
        color: #2395f3;
        margin-left: 10px;
        margin-top: 2px;
        word-break: keep-all;
    }

    :deep(.el-progress__text) {
        min-width: 40px;
        font-size: 12px !important;
    }

    .opt {
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 20px;

        img {
            cursor: pointer;

            &+img {
                margin-top: 5px;
            }
        }
    }
}
</style>
